import { useNavigate, useLocation } from "react-router-dom";
import Slider from "react-slick";
import {
  saveFlightBooking,
  makePaymentSession,
  createFlightBooking,
  directFlightBooking,
  validateOTP,
  sendOTP,
  confirmationEmail,
  changeRequest,
} from "../services/services";
import arrowWhiteIco from "./assets/img/arrowWhiteIco.png";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { MAKE_PAYMENT_SESSION, VERIFY_PAYMENT } from "../utils/constantAPI";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { formatDateWithWeekday } from "./formatDateWithWeekday";

import { useEffect, useState, useRef } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "./Footer";
import Header from "./Header";
import PlaneIco1 from "./assets/img/PlaneIco-1.png";
import captchaCode from "./assets/img/captchaCode.png";
import captchaImg from "./assets/img/captchaImg.png";
import saleImg from "./assets/img/saleImg.png";
import QRImg from "./assets/img/QRImg.png";
import giftImg from "./assets/img/giftImg.png";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { toast } from "react-toastify";
import { countryList, toastCSS } from "../services/commonHandler";
//import { saveFlightBooking } from "../services/services";
//import arrowWhiteIco from './assets/img/arrowWhiteIco.png';
//import { useLocation } from "react-router-dom";
//import {formatDateWithWeekday} from "./formatDateWithWeekday";

const TwoWayFlights = () => {
  const navigate = useNavigate();

  const [passengerType, setPassengerType] = useState("ADT");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationality, setNantionality] = useState("US");
  const [gender, setGender] = useState("Male");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [passportExpDate, setPassportExpDate] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneCountryCode,setPhoneCountryCode] = useState("+1");
  const [altPhoneCountryCode,setAltPhoneCountryCode] = useState("+1");
  const [isOpen, setIsOpen] = useState(true); // Default to open
  const [contactEmail, setContactEmail] = useState("");
  const [verifyEmail, setVerifyEmail] = useState("");
  const [mainContactNumber, setMainContactNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [showEmailError, setShowEmailError] = useState(false);
  const [showFirstNameError, setShowFirstNameError] = useState(false);
  const [showLastNameError, setShowLastNameError] = useState(false);
  const [showPassportExpDateError, setShowPassportExpDateError] =
    useState(false);
  const [showDateOfBirthError, setShowDateOfBirthError] = useState(false);
  const [showPassportNumberError, setShowPassportNumberError] = useState(false);
  const [showPhoneNumberError, setShowPhoneNumberError] = useState(false);
  const [showContactEmailError, setShowContactEmailError] = useState(false);
  const [showVerifyEmailError, setShowVerifyEmailError] = useState(false);
  const [showMainContactNumberError, setShowMainContactNumberError] =
    useState(false);
  const [noExpiration, setNoExpiration] = useState(false);
  const [showMobileNumberError, setShowMobileNumberError] = useState(false);
  const [passengers, setPassengers] = useState([
  {
    passengerType: "ADT",
    firstName: "",
    lastName: "",
    nationality: "US",
    gender: "Male",
    dateOfBirth: "",
    passportNumber: "",
    passportExpDate: "",
    phoneNumber: "",
    email: "",
    preferences: {
      assistance: "No Preference",
      seatPreference: "No Preference",
      frequentFlyerNumber: ""
    },
    meal: {
      code: "No Preference",
      description: "No Preference"
    },
    extraBaggage: {
      code: "",
      description: ""
    }
  }
]);
    const [isEditing, setIsEditing] = useState(false);
  
  const [passengerCounts, setPassengerCounts] = useState({
    adults: 0,
    children: 0,
    infants: 0,
  });
  const [airports, setAirports] = useState([]);
  const [convertedPrice, setConvertedPrice] = useState(null);
  const [flightSearchData, setFlightSearchData] = useState(null);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [sameEmail, setSameEmail] = useState(false);
  const [samePhone, setSamePhone] = useState(false);
  const location = useLocation();
  const {
    ItemCodeRef,
    SegmentCodeRefs,
    UniqueTransID,
    PriceCodeRef,
    Currency,
    TotalPrice,
  } = location.state || {};
  const { departureSegments, returnSegments } = location.state || {};
  useEffect(() => {
    const storedData = localStorage.getItem("flightSearchData");
    if (storedData) {
      const {
        fromLocation,
        toLocation,
        departureDate,
        returnDate,
        passengerCounts,
        seatClass,
      } = JSON.parse(storedData);

      if (passengerCounts) setPassengerCounts(passengerCounts);
    }
  }, []);
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);
  const detailFlightData = localStorage.getItem("DetailflightSearchData");
  const parsedFlightData = JSON.parse(detailFlightData);
  const totalPassengerCount =
    passengerCounts.adults + passengerCounts.children + passengerCounts.infants;
    function getPassengerTitle(passengerType, gender) {
  if (passengerType === "ADT") {
    return gender === "Male" ? "Mr" : "Ms"; 
  }
  if (passengerType === "CNN" || passengerType === "INF") {
    return gender === "Male" ? "MSTR" : "Miss";
  }
  return "Mr"; // default fallback
}

  useEffect(() => {
    const types = [];

    for (let i = 0; i < passengerCounts.adults; i++) types.push("ADT");
    for (let i = 0; i < passengerCounts.children; i++) types.push("CNN");
    for (let i = 0; i < passengerCounts.infants; i++) types.push("INF");

    const generated = types.map((type) => ({
      passengerType: type,
      title:"",
      firstName: "",
      lastName: "",
      nationality: "US",
      gender: "Male",
      dateOfBirth: "",
      passportNumber: "",
      passportExpDate: "",
      email: "",
      phone: "",
      preferences: {
        assistance: "No Preference",
        seatPreference: "No Preference",
        frequentFlyerNumber: ""
      },
      meal: {
        code: "No Preference",
        description: "No Preference"
      },
      extraBaggage: {
        code: "",
        description: ""
      }
    }));

    setPassengers(generated);
  }, [passengerCounts]);

  const dobRefs = useRef([]);
  const expRefs = useRef([]);
  useEffect(() => {
    setIsOtpSent(false);
    setIsValidated(false);
    setOtp("");
    setCountdown(0);
    setErrors({});
  }, [emailOrPhone]);
  useEffect(() => {
    passengers.forEach((_, index) => {
      const dobInput = dobRefs.current[index];
      const expInput = expRefs.current[index];

      if (dobInput) {
        flatpickr(dobInput, {
          dateFormat: "Y-m-d",
          defaultDate: passengers[index].dateOfBirth || null,
          onChange: (selectedDates, dateStr) => {
            const updated = [...passengers];
            updated[index].dateOfBirth = dateStr;
            setPassengers(updated);
          },
        });
      }

      if (expInput) {
        flatpickr(expInput, {
          dateFormat: "Y-m-d",
          defaultDate: passengers[index].passportExpDate || null,
          onChange: (selectedDates, dateStr) => {
            const updated = [...passengers];
            updated[index].passportExpDate = dateStr;
            setPassengers(updated);
          },
        });
      }
    });
  }, [passengers]);
  useEffect(() => {
    const datePicker = flatpickr("#dobPicker", {
      dateFormat: "Y-m-d",
      allowInput: true,
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
      onChange: (selectedDates, dateStr) => {
        setDateOfBirth(dateStr);
      },
    });

    const passportExpPicker = flatpickr("#passportExpPicker", {
      dateFormat: "Y-m-d",
      allowInput: true,
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
      onChange: (selectedDates, dateStr) => {
        setPassportExpDate(dateStr);
      },
    });

    const button = document.getElementById("addPassengerButton");
    const formDiv = document.querySelector(".addPassengerContentWrap");

    const handleClick = () => { 
      if (formDiv) {
        formDiv.style.display = "block";
      }
    };

    if (button && formDiv) {
      button.addEventListener("click", handleClick);
    }

    return () => {
      if (button) {
        button.removeEventListener("click", handleClick);
      }
    };
  }, []);
  // Run only once when the component mounts
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get("session_id");

    if (sessionId) {
      console.log("Payment Success! Session ID:", sessionId);

      //  Verify payment with backend
      verifyPayment(sessionId);
    }
  }, [location]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get("session_id");

    if (sessionId) {
      console.log("Payment Success! Session ID:", sessionId);

      //  Verify payment with backend
      verifyPayment(sessionId);
    }
  }, [location]);

  if (!location.state) {
    return (
      <div className="error-state">
        <Header />
        <div className="container">
          <h2>Missing Flight Information</h2>
          <p>Please start your booking process from the beginning</p>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/flights")}
          >
            Search Flights Again
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  const segments = location.state.segments || [];
  const firstSegment = segments[0] || {};

  const verifyPayment = async (sessionId) => {
    try {
      let response = await axios.post(VERIFY_PAYMENT, { sessionId });

      if (response.data.success) {
        console.log("Payment Verified! Proceeding with flight booking...");

        // Retrieve form data from localStorage
        const storedData = localStorage.getItem("flightBookingData");
        if (storedData) {
          finalizeFlightBooking(JSON.parse(storedData));
        }
      } else {
        console.error("Payment verification failed!");
      }
    } catch (error) {
      console.error("Payment verification error:", error);
    }
  };

  const PASSPORT_RULES = {
    US: { min: 9, max: 9, pattern: /^[A-Z0-9]{9}$/ },
    IN: { min: 6, max: 9, pattern: /^[A-Z][0-9]{7}$/ },
    UK: { min: 8, max: 10, pattern: /^[A-Z0-9]{8,10}$/ },
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePassport = (passportNumber, nationality) => {
    const countryRules = PASSPORT_RULES[nationality] || PASSPORT_RULES.US;
    return (
      passportNumber &&
      passportNumber.length >= countryRules.min &&
      passportNumber.length <= countryRules.max &&
      countryRules.pattern.test(passportNumber)
    );
  };

  const validateName = (name) => {
    return /^[a-zA-Z\s-]+$/.test(name) && name.length >= 2 && name.length < 25;
  };

  const validatePhoneNumber = (phoneNumber) => {
    return phoneNumber && phoneNumber.replace(/\D/g, "").length >= 8;
  };

  // const saveFlightBookingDetails = async () => {
  //   let isValid = true;

  //   // Validate each field and show error if needed
  //   if (!contactEmail || !validateEmail(contactEmail)) {
  //     setShowContactEmailError(true);
  //     isValid = false;
  //   } else {
  //     setShowContactEmailError(false);
  //   }

  //   if (!verifyEmail) {
  //     setShowVerifyEmailError(true);
  //     isValid = false;
  //   } else if (verifyEmail !== contactEmail) {
  //     setShowVerifyEmailError(true);
  //     isValid = false;
  //   } else {
  //     setShowVerifyEmailError(false);
  //   }

  //   if (!mainContactNumber) {
  //     setShowMainContactNumberError(true);
  //     isValid = false;
  //   } else {
  //     setShowMainContactNumberError(false);
  //   }

  //   if (!mobileNumber) {
  //     setShowMobileNumberError(true);
  //     isValid = false;
  //   } else {
  //     setShowMobileNumberError(false);
  //   }

  //   if (!firstName || !validateName(firstName)) {
  //     setShowFirstNameError(true);
  //     isValid = false;
  //   } else {
  //     setShowFirstNameError(false);
  //   }

  //   if (!lastName || !validateName(firstName)) {
  //     setShowLastNameError(true);
  //     isValid = false;
  //   } else {
  //     setShowLastNameError(false);
  //   }

  //   if (!noExpiration && !passportExpDate) {
  //     setShowPassportExpDateError(true);
  //     isValid = false;
  //   } else {
  //     setShowPassportExpDateError(false);
  //   }

  //   if (!dateOfBirth) {
  //     setShowDateOfBirthError(true);
  //     isValid = false;
  //   } else {
  //     setShowDateOfBirthError(false);
  //   }

  //   if (!passportNumber || !validatePassport(passportNumber, nationality)) {
  //     setShowPassportNumberError(true);
  //     isValid = false;
  //   } else {
  //     setShowPassportNumberError(false);
  //   }

  //   if (!phoneNumber || !validatePhoneNumber(phoneNumber)) {
  //     setShowPhoneNumberError(true);
  //     isValid = false;
  //   } else {
  //     setShowPhoneNumberError(false);
  //   }

  //   if (!email || !validateEmail(email)) {
  //     setShowEmailError(true);
  //     isValid = false;
  //   } else {
  //     setShowEmailError(false);
  //   }

  //   if (!isValid) {
  //     alert("Please fill in all required fields.");
  //     return;
  //   }

  //   //  If form is valid, proceed to payment
  //   console.log("Form validation passed! Redirecting to payment...");
  //   const usdAmount = Currency === 'USD'
  // ? parseFloat(TotalPrice)
  // : parseFloat(convertedPrice);
  // if (Currency !== 'USD' && !convertedPrice) {
  //   alert("Currency conversion not ready. Please wait a moment and try again.");
  //   return;
  // }
  // await makePayment(usdAmount);
  // };
  const saveFlightBookingDetails = async () => {
    let isValid = true;

    // Validate contact info (global)
    if (!contactEmail || !validateEmail(contactEmail)) {
      setShowContactEmailError(true);
      isValid = false;
    } else {
      setShowContactEmailError(false);
    }

    if (!verifyEmail || verifyEmail !== contactEmail) {
      setShowVerifyEmailError(true);
      isValid = false;
    } else {
      setShowVerifyEmailError(false);
    }

    if (!mainContactNumber) {
      setShowMainContactNumberError(true);
      isValid = false;
    } else {
      setShowMainContactNumberError(false);
    }

    if (!mobileNumber) {
      setShowMobileNumberError(true);
      isValid = false;
    } else {
      setShowMobileNumberError(false);
    }

    // Validate each passenger
    passengers.forEach((p, index) => {
      if (!p.firstName || !validateName(p.firstName)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid first name.`, toastCSS);
      }

      if (!p.lastName || !validateName(p.lastName)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid last name.`, toastCSS);
      }

      if (!p.dateOfBirth) {
        isValid = false;
        toast.error(
          `Passenger ${index + 1}: Date of birth is required.`,
          toastCSS
        );
      }

      if (!p.passportExpDate && !p.noExpiration) {
        isValid = false;
        toast.error(
          `Passenger ${index + 1}: Passport expiration date is required.`,
          toastCSS
        );
      }

      if (
        !p.passportNumber ||
        !validatePassport(p.passportNumber, p.nationality)
      ) {
        isValid = false;
        toast.error(
          `Passenger ${index + 1}: Invalid passport number.`,
          toastCSS
        );
      }

      if (!p.email || !validateEmail(p.email)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid email.`, toastCSS);
      }

      if (!p.phoneNumber || !validatePhoneNumber(p.phoneNumber)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid phone number.`, toastCSS);
      }
    });

    if (!isValid) {
      toast.error("Please fix the errors before proceeding.", toastCSS);
      return;
    }

    console.log("Validation passed! Proceeding to payment...");

    await makePayment(parseFloat(TotalPrice), Currency);
  };
  const handleNoExpirationChange = (e) => {
    const isChecked = e.target.checked;
    setNoExpiration(isChecked);
    if (isChecked) {
      setPassportExpDate("");
    }
  };

  const makePayment = async (amount, currency) => {
    const stripe = await loadStripe(
      //Live changes needed
      "pk_live_51N8QFdISzdvlhh7Qhw6y0EHx4ZCqduupbd1iohAb78dayk1Ceq3Q2Vkucv17BJJZUu4Km117eqeUBQyicOzpFlvW00AfDlv1Rn"
      //"pk_test_51OtYpRSAz7hIGu737oR8mSEZHpvkxdvQo199p6lE5TBujOtXftc5aq68prIJXGMz8hbAkVYKrgvHyVHsyN23FEXb00qFZfKq5n"
    );
    let flightBookingData = {
      uniqueTransId: UniqueTransID,
      itemCodeRef: ItemCodeRef,
      priceCodeRef: PriceCodeRef,
      totalAmount: amount,
      currency: Currency,
      bookingDate: new Date().toISOString().split("T")[0],
    };

    let contactInfo = {
      email: contactEmail,
      phone: mainContactNumber,
      phoneCountryCode: phoneCountryCode,
    };

    let passengersPayload = passengers.map((p) => ({
      passengerType: p.passengerType,
      title: getPassengerTitle(p.passengerType, p.gender),
      firstName: p.firstName,
      lastName: p.lastName,
      gender: p.gender,
      dateOfBirth: formatDate(p.dateOfBirth),
      passportNumber: p.passportNumber,
      PassportExpireDate: formatDate(p.passportExpDate),
      hasNoExpiration: p.noExpiration,
      nationality: p.nationality,
      isWheelchair: false,
      issuingCountry: "US",
      phoneCountryCode: phoneCountryCode,
      phone: p.phoneNumber,
      email: p.email,
      meal: {
        code: p.meal.code,
        description: p.meal.description,
      },
      extraBaggage: {
        code: p.extraBaggage.code,
        description: p.extraBaggage.description,
      },
      preferences: {
        assistance: p.preferences.assistance,
        seatPreference: p.preferences.seatPreference,
        frequentFlyerNumber: p.preferences.frequentFlyerNumber
      }
    }));

    let finalData = {
      flightBooking: flightBookingData,
      contactInfo: contactInfo,
      passengerDetails: passengersPayload,
      searchData: detailFlightData,
    };

    //  Save to localStorage before redirecting to Stripe
    localStorage.setItem("flightBookingData", JSON.stringify(finalData));
    await saveFlightBooking(
      finalData,
      (response) => {
        const bookingId = response?.bookingId;
       localStorage.setItem("bookingId", bookingId);
        return response;
      },
      (error) => {
        // alert("Error saving flight booking data. Please try again.");
        console.log(error);
        return error;
      }
    );

    let paymentData = [
      {
        totalAmount: amount,
        currency: Currency,
        bookingDate: new Date().toISOString().split("T")[0],
      },
    ];

    try {
      let response = await axios.post(MAKE_PAYMENT_SESSION, paymentData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data && response.data.id) {
        console.log("Payment Session Created:", response.data);

        //  Redirect user to Stripe checkout
        const result = await stripe.redirectToCheckout({
          sessionId: response.data.id,
        });

        if (result.error) {
          console.error("Stripe Checkout Error:", result.error);
        }
      } else {
        console.error("Invalid response from server:", response);
      }
    } catch (error) {
      console.error("Payment Error:", error);
    }
  };
  function formatDate(inputDate) {
    if (!inputDate) return null;

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return null;

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${mm}-${dd}-${yyyy}`;
  }

  function formatDatePayload(inputDate) {
    if (!inputDate) return null;

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return null;

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${yyyy}-${mm}-${dd}`;
  }
  const finalizeFlightBooking = async (bookingData) => {
    if (!bookingData) {
      console.error("No booking data provided!");
      return;
    }

    let formattedData = {
      PassengerInfoes: bookingData.passengerDetails.map((passenger) => ({
        PassengerType: passenger.passengerType,
        Title: getPassengerTitle(passenger.passengerType, passenger.gender),
        FirstName: passenger.firstName,
        LastName: passenger.lastName,
        Gender: passenger.gender,
        DateOfBirth: formatDatePayload(passenger.dateOfBirth),
        PassportNumber: passenger.passportNumber,
        PassportExpireDate: formatDatePayload(passenger.PassportExpireDate),
        Nationality: passenger.nationality,
        IsWheelchair: passenger.isWheelchair,
        IssuingCountry: passenger.issuingCountry,
        PhoneCountryCode: passenger.phoneCountryCode,
        Phone: passenger.phone,
        Email: passenger.email,
      })),
      ContactInfo: {
        Email: bookingData.contactInfo.email,
        Phone: bookingData.contactInfo.phone,
        PhoneCountryCode: bookingData.contactInfo.phoneCountryCode,
      },
      UniqueTransID: bookingData.flightBooking.uniqueTransId,
      ItemCodeRef: bookingData.flightBooking.itemCodeRef,
      PriceCodeRef: bookingData.flightBooking.priceCodeRef,
    };

    try {
      if (parsedFlightData.Bookable === true) {
        await createFlightBooking(formattedData, onSuccess, onError);
      } else {
        await directFlightBooking(formattedData, onSuccess, onError);
      }
    } catch (error) {
      console.error("Booking Error:", error);
    }
  };
  const getCityByIata = (iataCode) => {
    const airport = airports.find((airport) => airport.iata === iataCode);
    return airport ? airport.city : iataCode;
  };

const onSuccess = async (response) => {
    const hasAdditionalBaggage = localStorage.getItem('requestAdditionalBaggage') === 'true';
    
    if (response?.error?.code === 400 || response?.code === 400) {
        if (response?.message === 'Insufficient Balance') {
            const flightBookingData = JSON.parse(localStorage.getItem("flightBookingData"));    
            const parseSerchData = JSON.parse(flightBookingData.searchData);
            const email = flightBookingData?.contactInfo?.email;
            const phone = flightBookingData?.contactInfo?.phoneCountryCode + flightBookingData?.contactInfo?.phone;
            const passengerName = `${flightBookingData?.passengerDetails[0]?.firstName || ''} ${flightBookingData?.passengerDetails[0]?.lastName || ''}`.trim();
            const bookingRef = flightBookingData?.flightBooking?.uniqueTransId;
            
            const destination = parseSerchData.Directions?.[0]?.[0]?.DestinationName;
            const departureDateTime = parseSerchData?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure;
            const date = departureDateTime?.split(" ")[0];
            const time = departureDateTime?.split(" ")[1];

            const fallbackBookingData = {
                BookingTransactionRef: bookingRef,
                BookingStatus: "BOOKED",
            };
            
            const emailData = {
                email: email,
                phone: phone,
                passengerName: passengerName,
                bookingRef: bookingRef,
                destination: destination,
                date: date,
                time: time,
                additionalBaggage: hasAdditionalBaggage 
            };

            if (hasAdditionalBaggage) {
                try {
                  const bookingId = localStorage.getItem("bookingId");
                     if (bookingId) {
                      await changeRequest(
                        {
                            bookingId,
                            reasonType: ["Additional Baggage"],
                            details:"Automatic baggage request from booking"
                            
                        },
                        () => console.log("Fallback baggage request created"),
                        (error) => console.error("Failed to create fallback baggage request:", error)
                    );
                  }
                } catch (error) {
                    console.error('Error creating fallback baggage request:', error);
                }
            }
            localStorage.removeItem("bookingId");
            await confirmationEmail(
                emailData,
                () => {
                    console.log("Fallback email sent for insufficient balance");
                    localStorage.removeItem('requestAdditionalBaggage'); // Cleanup
                },
                (error) => {
                    console.error("Failed to send fallback email:", error);
                    localStorage.removeItem('requestAdditionalBaggage'); // Cleanup
                }
            );

            navigate("/BookingConfirmation", {
                state: { bookingData: fallbackBookingData },
            });
            return;
        } else {
            localStorage.removeItem('requestAdditionalBaggage'); // Cleanup even on error
            navigate('/ErrorPage', {
                state: {
                    errorMessage: response.error?.message || response?.message || "Something went wrong with flight booking.",
                },
            });
            return;
        }
    }

    // Handle successful booking
    const bookingData = response.booking.data;
    const passenger = bookingData?.TicketInfoes?.[0]?.PassengerInfo;
    const contact = passenger?.ContactInfo;
    const name = `${passenger?.NameElement?.FirstName} ${passenger?.NameElement?.LastName}`;
    const destination = bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Destination;
    const travelDate = bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure?.split(" ")[0];
    const time = bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure?.split(" ")[1];

    // Create baggage request if needed
    if (hasAdditionalBaggage) {
        try {
          const bookingId = localStorage.getItem("bookingId");
           if (bookingId) {
            await changeRequest(
                {
                    bookingId,
                    reasonType: ["Additional Baggage"],
                    details: "Automatic baggage request from booking" 
                },
                () => console.log("Baggage request created successfully"),
                (error) => console.error("Failed to create baggage request:", error)
            );
          }
        } catch (error) {
            console.error('Error creating baggage request:', error);
        }
    }
    localStorage.removeItem("bookingId");
    // Prepare email data
    const emailData = {
        email: contact?.Email,
        phone: contact?.PhoneCountryCode + contact?.Phone,
        passengerName: name,
        bookingRef: bookingData?.uniqueTransId ||bookingData?.BookingTransactionRef,
        destination,
        date: travelDate,
        time,
        additionalBaggage: hasAdditionalBaggage
    };

    // Send confirmation email
    await confirmationEmail(
        emailData,
        (emailResponse) => {
            console.log("Initial email sent successfully:", emailResponse);
            localStorage.removeItem('requestAdditionalBaggage'); // Cleanup
            navigate("/BookingConfirmation", {
                state: { bookingData: bookingData },
            });
        },
        (error) => {
            console.error("Failed to send initial email:", error);
            localStorage.removeItem('requestAdditionalBaggage'); // Cleanup
            navigate("/BookingConfirmation", {
                state: { bookingData: bookingData },
            });
        }
    );
};
  const onError = (error) => {
    console.log(error);
  };
  const handleSendOTP = async () => {
    setErrors({});
    if (!emailOrPhone) {
      setErrors({ emailOrPhone: "Email/Phone is required" });
      return;
    }
    setIsValidating(true);
    try {
      await sendOTP(
        { email: emailOrPhone },
        (res) => {
          setIsOtpSent(true);
          setCountdown(60); // 60 seconds cooldown
        },
        (err) => {
          setErrors({
            emailOrPhone: err.response?.data?.error || "Failed to send OTP",
          });
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsValidating(false);
    }
  };
  const handleValidateOTP = async () => {
    setErrors({});
    if (!otp) {
      setErrors({ otp: "OTP is required" });
      return;
    }

    try {
      await validateOTP(
        { email: emailOrPhone, otp },
        (res) => {
          toast.success("OTP validated successfully!", toastCSS);
          setIsValidated(true);
          setIsEmailVerified(true);
          setIsEditing(false);
          setContactEmail(emailOrPhone);
          setVerifyEmail(emailOrPhone);
          setCountdown(0);
          setIsOtpSent(false);
        },
        (err) => {
          setErrors({ otp: err.response?.data?.error || "Invalid OTP" });
        }
      );
    } catch (error) {
      console.error(error);
    }
  };
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  const calculateTotalTravelTime = (segments) => {
    if (!segments || segments.length === 0) return "0h 0m";

    const firstDeparture = new Date(segments[0].Departure);
    const lastArrival = new Date(segments[segments.length - 1].Arrival);

    const totalMs = lastArrival - firstDeparture;
    const hours = Math.floor(totalMs / (1000 * 60 * 60));
    const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}h ${minutes}m`;
  };
  const handleSameEmailChange = (e) => {
    let isChecked = e.target.checked;
    if (isChecked) {
      const updatedPassengers = passengers.map((passenger) => ({
        ...passenger,
        email: verifyEmail,
      }));
      setPassengers(updatedPassengers);
    }
  };
  const handelSamePhoneNumber = (e) => {
    const isChecked = e.target.checked;
    setSamePhone(isChecked);

    if (isChecked) {
      const updatedPassengers = passengers.map((passenger) => ({
        ...passenger,
        phoneNumber: mainContactNumber,
      }));
      setPassengers(updatedPassengers);
    }
  };
  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="flightProgressWrap">
          <div className="flightProgressInner">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-6">
                  <ul>
                    <li>
                      <div className="itemWrap completed">
                        <div className="noWrap">
                          <div className="icoWrap">
                            <img
                              src={arrowWhiteIco}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <p>Review Selection</p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap active">
                        <div className="noWrap">
                          <h2>2</h2>
                          <p>Enter Details</p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap">
                        <div className="noWrap">
                          <h2>3</h2>
                          <p>Make Payment</p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap">
                        <div className="noWrap">
                          <h2>4</h2>
                          <p>Booking Confirmation</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flightReservWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Flight Reservation/Booking Passenger Details</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-9">
                <div className="leftPannelWrap">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="flightReservDeparWrap">
                        <div className="row justify-content-center">
                          <div className="col-xl-5 col-sm-5 col-12">
                            <div className="depRetWrap">
                              <h3>Departure</h3>

                              <ul>
                                <li>
                                  <div className="itemWrap">
                                    <div className="boxWrap">
                                      <h2>
                                        {departureSegments?.[0]?.Departure.split(
                                          " "
                                        )[1].slice(0, 5)}
                                      </h2>
                                      <p>
                                        {formatDateWithWeekday(
                                          departureSegments?.[0]?.Departure
                                        )}
                                      </p>
                                    </div>
                                    <div className="boxWrap">
                                      <h2>
                                        {departureSegments?.[
                                          departureSegments.length - 1
                                        ]?.Arrival.split(" ")[1].slice(0, 5)}
                                      </h2>
                                      <p>
                                        {formatDateWithWeekday(
                                          departureSegments?.[
                                            departureSegments.length - 1
                                          ]?.Arrival
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="itemWrap">
                                    <div className="boxWrap boxBigWrap">
                                      <p>
                                        {departureSegments?.[0]
                                          ?.Duration?.[0] || "Duration N/A"}
                                      </p>
                                      <p className="clrTxt">
                                        {departureSegments?.[0]?.Transit ||
                                          "Non-Transit"}
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="itemWrap midIcoWrap">
                                    <div className="icoWrap roundIco"></div>
                                    <div className="icoWrap roundIco"></div>
                                  </div>
                                </li>
                                <li>
                                  <div className="itemWrap">
                                    <div className="boxWrap">
                                      <h2>
                                        {departureSegments?.[0]?.Origin ||
                                          "Origin"}
                                      </h2>
                                    </div>
                                    <div className="boxWrap">
                                      <h2>
                                        {departureSegments?.[
                                          departureSegments.length - 1
                                        ]?.Destination || " Destination"}
                                      </h2>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-xl-5 col-sm-5 col-12">
                            {returnSegments?.length > 0 && (
                              <div className="depRetWrap twoWayDepRetWrap">
                                <div className="swipeWrap">
                                  <svg
                                    width="20"
                                    height="14"
                                    viewBox="0 0 20 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5 5H19L15 1M15 9H1L5 13"
                                      stroke="black"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                                <h3>Return</h3>
                                <ul>
                                  <li>
                                    <div className="itemWrap">
                                      <div className="boxWrap">
                                        <h2>
                                          {returnSegments?.[0]?.Departure.split(
                                            " "
                                          )[1].slice(0, 5)}
                                        </h2>
                                        <p>
                                          {formatDateWithWeekday(
                                            returnSegments?.[0]?.Departure
                                          )}
                                        </p>
                                      </div>
                                      <div className="boxWrap">
                                        <h2>
                                          {returnSegments?.[
                                            returnSegments.length - 1
                                          ]?.Arrival.split(" ")[1].slice(0, 5)}
                                        </h2>
                                        <p>
                                          {formatDateWithWeekday(
                                            returnSegments?.[
                                              returnSegments.length - 1
                                            ]?.Arrival
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="itemWrap">
                                      <div className="boxWrap boxBigWrap">
                                        <p>
                                          {returnSegments?.[0]?.Duration?.[0] ||
                                            "Duration N/A"}
                                        </p>
                                        <p className="clrTxt">
                                          {returnSegments?.[0]?.Transit ||
                                            "Non-Transit"}
                                        </p>
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="itemWrap midIcoWrap">
                                      <div className="icoWrap roundIco roundIcoLeft"></div>
                                      <div className="icoWrap roundIco roundIcoRight"></div>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="itemWrap">
                                      <div className="boxWrap">
                                        <h2>
                                          {returnSegments?.[0]?.Origin ||
                                            "Departure Airport"}
                                        </h2>
                                      </div>
                                      <div className="boxWrap">
                                        <h2>
                                          {returnSegments?.[
                                            returnSegments.length - 1
                                          ]?.Destination || "Destination"}
                                        </h2>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="passengerDtlsWrap topPassengerDtlsWrap">
                        <div className="validEmailWrap">
                          <h3>Please validate your email</h3>
                        </div>
                        <form onSubmit={(e) => e.preventDefault()}>
                          <div className="row justify-content-between align-items-start">
                            <div className="col-md-6">
                              <ul className="formList">
                                <li className="half">
                                  <div className="inputField">
                                    <label>Email</label>
                                    <div className="inputWithBtn">
                                      <input
                                        value={emailOrPhone}
                                        onChange={(e) =>
                                          setEmailOrPhone(e.target.value)
                                        }
                                        disabled={isOtpSent || isValidated}
                                      />
                                      
                                    </div>
                                    {errors.emailOrPhone && (
                                      <p className="ErrorMsg">
                                        {errors.emailOrPhone}
                                      </p>
                                    )}
                                    <button
                                      type="button"
                                      className={`verifyBtn btn ${
                                        isValidated ? "verified" : ""
                                      } ${!emailOrPhone ? "disabled" : ""}`}
                                      onClick={() => {
                                        if (!isValidated || isEditing) {
                                          handleSendOTP();
                                        }
                                      }}
                                      disabled={
                                        (isValidated && !isEditing) ||
                                        countdown > 0 ||
                                        !emailOrPhone ||
                                        isValidating
                                      }
                                    >
                                      {isValidating ? (
                                        "Validating..."
                                      ) : isValidated ? (
                                        isEditing ? (
                                          "Re-validate"
                                        ) : (
                                          <span className="verified-content">
                                            Verified ✓
                                            
                                          </span>
                                        )
                                      ) : countdown > 0 ? (
                                        `Resend in 00:${String(
                                          countdown
                                        ).padStart(2, "0")}`
                                      ) : (
                                        "Validate"
                                      )}
                                    </button>
                                  </div>
                                </li>
                                {isOtpSent && !isValidated && (
                                  <li className="half">
                                    <div className="inputField">
                                      <label>OTP</label>
                                      <input
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                      />
                                      <div className="BtmWrap">
                                        {errors.otp && (
                                          <p className="ErrorMsg">
                                            {errors.otp}
                                          </p>
                                        )}
                                        <button
                                          type="button"
                                          className="btn"
                                          disabled={countdown > 0}
                                          onClick={handleSendOTP}
                                        >
                                          {/* Resend {countdown > 0 ? `00:${String(countdown).padStart(2, "0")}` : ""} */}
                                        </button>
                                        <button
                                          type="button"
                                          className="verifyBtn btn"
                                          onClick={handleValidateOTP}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </li>
                                )}
                              </ul>
                            </div>
                            <div className="col-md-5">
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="passengerDtlsWrap">
                        <div className="topTtlWrap">
                          <h3>Passengers Details</h3>
                        </div>
                        <div
                          className={`flightReservContactDtlWrap ${
                            !isValidated ? "disabled-form" : ""
                          }`}
                        >
                          {!isValidated && (
                            <div className="form-overlay">
                              <p>Please validate your email first</p>
                            </div>
                          )}
                          <div className="contactDtlsWrap">
                            <div className="topFilterWrap">
                              <div className="leftWrap">
                                <h4>Contact Details</h4>
                                <p>
                                  Your ticket & flight information will be sent
                                  here
                                </p>
                              </div>
                              <button
                                className="btn"
                                type="button"
                                onClick={() => {
                                  // setContactEmail('');
                                  // setVerifyEmail('');
                                  setMainContactNumber("");
                                  setMobileNumber("");
                                }}
                              >
                                Clear Details
                              </button>
                            </div>
                            <form>
                              <ul className="formList">
                                <li className="fourth">
                                  <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                    <label>Primary Email Address</label>
                                    <input
                                      type="email"
                                      value={verifyEmail}
                                      onChange={(e) =>
                                        setVerifyEmail(e.target.value)
                                      }
                                      placeholder="verified Email Address"
                                      disabled={!isValidated || isEmailVerified}
                                    />
                                    {showContactEmailError && (
                                      <p className="ErrorMsg">
                                        Invalid email (e.g., john@domain.com)
                                      </p>
                                    )}
                                  </div>
                                </li>
                                <li className="fourth">
                                  <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                    <label>Re-enter Primary Email </label>
                                    <input
                                      type="email"
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (value !== verifyEmail) {
                                          setShowVerifyEmailError(true);
                                        } else {
                                          setShowVerifyEmailError(false);
                                        }
                                      }}
                                      placeholder="Re-enter email"
                                      disabled={!isValidated}
                                    />
                                    {showVerifyEmailError && (
                                      <p className="ErrorMsg">
                                        Emails do not match or are empty
                                      </p>
                                    )}
                                  </div>
                                </li>
                                <li className="fourth">
                                  <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                    <label> Primary Contact Number</label>
                                    <PhoneInput
                                      country={"us"}
                                      value={mainContactNumber}
                                      onChange={(e,countryData) => {
                                        setMainContactNumber(e);
                                        setPhoneCountryCode(
                                          countryData.dialCode || "+1"
                                        );
                                      }}
                                      inputProps={{
                                        required: true,
                                        name: "mainContactNumber",
                                      }}
                                      disabled={!isValidated}
                                    />
                                    {showMainContactNumberError && (
                                      <p className="ErrorMsg">
                                        Please enter a Primary Contact Number
                                      </p>
                                    )}
                                  </div>
                                </li>
                                <li className="fourth">
                                  <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                    <label>Alternate Mobile Number</label>
                                    <PhoneInput
                                      country={"us"}
                                      value={mobileNumber}
                                      onChange={(e, countryData) => {
                                        setMobileNumber(e);
                                        setAltPhoneCountryCode(
                                          countryData.dialCode || "+1"
                                        );
                                      }}
                                      inputProps={{
                                        required: true,
                                        name: "mobileNumber",
                                      }}
                                      disabled={!isValidated}
                                    />
                                    {showMobileNumberError && (
                                      <p className="ErrorMsg">
                                        Please enter your mobile number
                                      </p>
                                    )}
                                    <div class="noteWrap">
                                      <p>
                                        We ask for your mobile number so we can
                                        call or text you about changes to your
                                        itinerary, or provide helpful
                                        information about your trip.
                                      </p>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </form>
                          </div>

                          <div id="passengerAccordion">
                            {passengers.map((passenger, index) => (
                              <div className="accordion-item" key={index}>
                                {/* OUTER ACCORDION HEADER */}
                                <h2
                                  className="accordion-header"
                                  id={`heading${index}`}
                                >
                                  <button
                                    className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse${index}`}
                                    aria-expanded="false"
                                    aria-controls={`collapse${index}`}
                                  >
                                    <div className="topFilterWrap">
                                      <h4>Passenger {index + 1}</h4>
                                      <div className="selectWrap">
                                        <select
                                          value={passengerType}
                                          onChange={(e) =>
                                            setPassengerType(e.target.value)
                                          }
                                        >
                                          <option value="ADT">
                                            Adult (over 12 years)
                                          </option>
                                          <option value="CHILD">
                                            Children (below 12 years)
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </button>
                                </h2>

                                <div
                                  id={`collapse${index}`}
                                  className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                  aria-labelledby={`heading${index}`}
                                  data-bs-parent="#passengerAccordion"
                                >
                                  <div className="accordion-body">
                                    <div className="topInfoWrap">
                                      <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.2038 7.81884V11.7658M11.2038 14.726V14.7358M20.0844 10.779C20.0844 15.6837 16.1085 19.6596 11.2038 19.6596C6.29922 19.6596 2.32324 15.6837 2.32324 10.779C2.32324 5.87442 6.29922 1.89844 11.2038 1.89844C16.1085 1.89844 20.0844 5.87442 20.0844 10.779Z"
                                          stroke="#228BE6"
                                          strokeWidth="2.9602"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <p>
                                        Use all given names and surnames{" "}
                                        <span>
                                          exactly as they appear in your
                                          passport/ID
                                        </span>{" "}
                                        to avoid boarding complications.
                                      </p>
                                    </div>
                                    <form>
                                      <ul className="formList">
                                        <li className="third">
                                          <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                            <label>First and Middle Name</label>
                                            <input
                                              placeholder="e.g. John Doe"
                                              value={passenger.firstName}
                                              onChange={(e) => {
                                                const updated = [...passengers];
                                                const value = e.target.value;
                                                if (
                                                  /^[a-zA-Z\s-]*$/.test(
                                                    value
                                                  ) &&
                                                  value.length <= 25
                                                ) {
                                                  updated[index].firstName =
                                                    value;
                                                  setPassengers(updated);
                                                }
                                              }}
                                              maxLength={25}
                                              disabled={!isValidated}
                                            />
                                            {showFirstNameError && (
                                              <p className="ErrorMsg">
                                                Please enter a valid first name
                                                (2-25 characters)
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third">
                                          <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                            <label>Surname</label>
                                            <input
                                              placeholder="e.g. Bobby"
                                              value={passenger.lastName}
                                              onChange={(e) => {
                                                const updated = [...passengers];
                                                const value = e.target.value;
                                                if (
                                                  /^[a-zA-Z\s-]*$/.test(
                                                    value
                                                  ) &&
                                                  value.length <= 25
                                                ) {
                                                  updated[index].lastName =
                                                    value;
                                                  setPassengers(updated);
                                                }
                                              }}
                                              maxLength={25}
                                              disabled={!isValidated}
                                            />
                                            {showLastNameError && (
                                              <p className="ErrorMsg">
                                                Please enter your surname (2-25
                                                characters)
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third pad0">
                                          <ul className="subFrmList">
                                            <li className="half">
                                              <div className="inputField">
                                                <label>Nationality</label>
                                                <div className="selectWrap">
                                                  <select
                                                    value={
                                                      passenger.nationality
                                                    }
                                                    onChange={(e) => {
                                                      const updated = [
                                                        ...passengers,
                                                      ];
                                                      updated[
                                                        index
                                                      ].nationality =
                                                        e.target.value;
                                                      setPassengers(updated);
                                                    }}
                                                    disabled={!isValidated}
                                                  >
                                                    {countryList.map(
                                                      (val, index) => (
                                                        <option
                                                          key={index}
                                                          value={val.code}
                                                        >
                                                          {val.name}
                                                        </option>
                                                      )
                                                    )}
                                                    {/* <option>US</option>
                                                    <option>Indian</option> */}
                                                  </select>
                                                </div>
                                              </div>
                                            </li>
                                            <li className="half">
                                              <div className="inputField">
                                                <label>Gender</label>
                                                <div className="selectWrap" title={!isValidated ? "Please validate your email first" : ""}>
                                                  <select
                                                    value={passenger.gender}
                                                    onChange={(e) => {
                                                      const updated = [
                                                        ...passengers,
                                                      ];
                                                      updated[index].gender =
                                                        e.target.value;
                                                      setPassengers(updated);
                                                    }}
                                                    disabled={!isValidated}
                                                  >
                                                    <option>Male</option>
                                                    <option>Female</option>
                                                    {/* <option>Others</option> */}
                                                  </select>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </li>
                                        <li className="third">
                                          <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                            <label>Date of birth</label>
                                            <div class="datePickerWrap">
                                              <input
                                                placeholder="dd/mm/yyyy"
                                                //id="datepicker"
                                                ref={(el) =>
                                                  (dobRefs.current[index] = el)
                                                }
                                                type="text"
                                                value={passenger.dateOfBirth}
                                                onChange={(e) => {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[index].dateOfBirth =
                                                    e.target.value;
                                                  setPassengers(updated);
                                                }}
                                                disabled={!isValidated}
                                              />
                                            </div>
                                            {showDateOfBirthError && (
                                              <p className="ErrorMsg">
                                                Please enter your date of birth
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third">
                                          <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                            <label>Passport Number</label>
                                            <input
                                              placeholder="Passport number..."
                                              value={passenger.passportNumber}
                                              onChange={(e) => {
                                                const updated = [...passengers];
                                                const value =
                                                  e.target.value.toUpperCase();
                                                const countryRules =
                                                  PASSPORT_RULES[
                                                    passenger.nationality
                                                  ] || PASSPORT_RULES.US;
                                                if (
                                                  /^[A-Z0-9]*$/.test(value) &&
                                                  value.length <=
                                                    countryRules.max
                                                ) {
                                                  updated[
                                                    index
                                                  ].passportNumber = value;
                                                  setPassengers(updated);
                                                }
                                              }}
                                              disabled={!isValidated}
                                            />
                                            {showPassportNumberError && (
                                              <p className="ErrorMsg">
                                                {/* Error message as before */}
                                              </p>
                                            )}
                                          </div>
                                        </li>

                                        <li className="third noExpirationWrap">
                                          <div className="inputField">
                                            <label>
                                              Passport expiration date
                                            </label>
                                            <div className="datePickerWrap">
                                              <input
                                                placeholder="dd/mm/yyyy"
                                                //id="passportExpDate"
                                                ref={(el) =>
                                                  (expRefs.current[index] = el)
                                                }
                                                type="text"
                                                value={
                                                  passenger.passportExpDate
                                                }
                                                // onChange={(e) => setPassportExpDate(e.target.value)}
                                                // onChange={(e) => {
                                                //   const updated = [...passengers];
                                                //   updated[index].passportExpDate = e.target.value;
                                                //   setPassengers(updated);
                                                // }}
                                                onChange={(e) => {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[
                                                    index
                                                  ].passportExpDate =
                                                    e.target.value;
                                                  setPassengers(updated);
                                                }}
                                                disabled={!isValidated}
                                              />
                                            </div>
                                            {showPassportExpDateError && (
                                              <p className="ErrorMsg">
                                                Please enter passport expiration
                                                date
                                              </p>
                                            )}
                                          </div>
                                        </li>

                                        <li className="third marTTop">
                                          <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                            <label>Email Address</label>
                                            <input
                                              value={
                                                sameEmail
                                                  ? verifyEmail
                                                  : passenger.email
                                              }
                                              onChange={(e) => {
                                                if (!sameEmail) {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[index].email =
                                                    e.target.value;
                                                  setPassengers(updated);
                                                }
                                              }}
                                            />
                                            <div className="checkBoxWrap">
                                              <input
                                                type="checkbox"
                                                id="sameEmail"
                                                onChange={handleSameEmailChange}
                                                disabled={
                                                  sameEmail || !isValidated
                                                }

                                                // onChange={() => {
                                                //   const updated = [...passengers];
                                                //   updated[index].noExpiration = !updated[index].noExpiration;
                                                //   setPassengers(updated);
                                                // }}
                                              />
                                              <label htmlFor="sameEmail">
                                                Same as Primary Email
                                              </label>
                                            </div>
                                            {showEmailError && (
                                              <p className="ErrorMsg">
                                                Invalid email (e.g.,
                                                john@domain.com)
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third marTTop">
                                          <div className="inputField" title={!isValidated ? "Please validate your email first" : ""}>
                                            <label>Mobile Number</label>
                                            <PhoneInput
                                              country={"us"}
                                              value={
                                                samePhone
                                                  ? mainContactNumber
                                                  : passenger.phoneNumber
                                              }
                                              onChange={(value, countryData) => {
                                                if (!samePhone) {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[index].phoneNumber =
                                                    value;
                                                   setPhoneCountryCode(
                                                  countryData.dialCode || "+1"
                                                );
                                                  setPassengers(updated);
                                                }
                                              }}
                                              inputProps={{
                                                required: true,
                                                name: "phoneNumber",
                                              }}
                                              disabled={
                                                samePhone || !isValidated
                                              }
                                            />
                                            <div className="checkBoxWrap">
                                              <input
                                                type="checkbox"
                                                id="samePhoneNumber"
                                                onChange={handelSamePhoneNumber}
                                                // onChange={() => {
                                                //   const updated = [...passengers];
                                                //   updated[index].noExpiration = !updated[index].noExpiration;
                                                //   setPassengers(updated);
                                                // }}
                                              />
                                              <label htmlFor="samePhoneNumber">
                                                Same as Primary Phone Number
                                              </label>
                                            </div>
                                            {showPhoneNumberError && (
                                              <p className="ErrorMsg">
                                                Please enter your mobile number
                                              </p>
                                            )}
                                            <div className="noteWrap">
                                              <p>
                                                We ask for your mobile number so
                                                we can call or text you about
                                                changes to your itinerary, or
                                                provide helpful information
                                                about your trip.
                                              </p>
                                            </div>
                                          </div>
                                        </li>
                                        <li className="third"></li>
                                      </ul>

                                      <div
                                        className="accordion"
                                        id="accordionExample"
                                      >
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <div className="accordion-button">
                                              <h3>Additional Information</h3>
                                            </div>
                                          </h2>
                                          <div className="accordion-body show">
                                            <ul className="formList">
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>Assistance</label>
                                                  <div className="selectWrap">
                                                    <select
                                                      defaultValue="No Preference"
                                                      value={passenger.preferences?.assistance || "No Preference"}
                                                      onChange={(e) => {
                                                        const updated = [...passengers];
                                                        updated[index].preferences.assistance = e.target.value;
                                                        setPassengers(updated);
                                                      }}
                                                    >
                                                      <option value="No Preference">
                                                        No Preference
                                                      </option>
                                                      <option value="Deaf">
                                                        Deaf
                                                      </option>
                                                      <option value="Blind">
                                                        Blind
                                                      </option>
                                                      <option value="Wheelchair">
                                                        Wheelchair
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                              </li>
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>Seat Preference</label>
                                                  <div className="selectWrap">
                                                    <select
                                                      defaultValue="No Preference"
                                                      value={passenger.preferences?.seatPreference || "No Preference"}
                                                      onChange={(e) => {
                                                        const updated = [...passengers];
                                                        updated[index].preferences.seatPreference = e.target.value;
                                                        setPassengers(updated);
                                                      }}
                                                    >
                                                      <option value="No Preference">
                                                        No Preference
                                                      </option>
                                                      <option value="Window">
                                                        Window
                                                      </option>
                                                      <option value="Aisle">
                                                        Aisle
                                                      </option>
                                                      <option value="Right">
                                                        Right
                                                      </option>
                                                      <option value="Left">
                                                        Left
                                                      </option>
                                                      <option value="Front">
                                                        Front
                                                      </option>
                                                      <option value="Tail">
                                                        Tail
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                              </li>
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>Meal Preference</label>
                                                  <div className="selectWrap">
                                                    <select
                                                      defaultValue="No Preference"
                                                      value={passenger.meal?.code || "No Preference"}
                                                      onChange={(e) => {
                                                        const updated = [...passengers];
                                                        updated[index].meal = {
                                                          code: e.target.value,
                                                          description: e.target.value
                                                        };
                                                        setPassengers(updated);
                                                      }}
                                                    >
                                                      <option value="No Preference">
                                                        No Preference
                                                      </option>
                                                      <option value="Kosher">
                                                        Kosher
                                                      </option>
                                                      <option value="Halal">
                                                        Halal
                                                      </option>
                                                      <option value="Low cholesterol">
                                                        Low cholesterol
                                                      </option>
                                                      <option value="Low Sodium">
                                                        Low Sodium
                                                      </option>
                                                      <option value="Vegan">
                                                        Vegan
                                                      </option>
                                                      <option value="Vegetarian">
                                                        Vegetarian
                                                      </option>
                                                      <option value="Baby food">
                                                        Baby food
                                                      </option>
                                                      <option value="Child">
                                                        Child
                                                      </option>
                                                      <option value="Diabetic">
                                                        Diabetic
                                                      </option>
                                                      <option value="Gluten free">
                                                        Gluten free
                                                      </option>
                                                      <option value="Hindu">
                                                        Hindu
                                                      </option>
                                                      <option value="Sea Food">
                                                        Sea Food
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                              </li>
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>
                                                    Frequent Flyer Number
                                                  </label>
                                                  <input
                                                    type="text"
                                                    value={passenger.preferences?.frequentFlyerNumber}
                                                    onChange={(e) => {
                                                      const updated = [...passengers];
                                                      updated[index].preferences.frequentFlyerNumber = e.target.value;
                                                      setPassengers(updated);
                                                    }}
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="btmNoteWrap">
                                        <div className="icoWrap">
                                          <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 22 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M11.2038 7.88915V11.8361M11.2038 14.7963V14.8062M20.0844 10.8494C20.0844 15.754 16.1085 19.73 11.2038 19.73C6.29922 19.73 2.32324 15.754 2.32324 10.8494C2.32324 5.94473 6.29922 1.96875 11.2038 1.96875C16.1085 1.96875 20.0844 5.94473 20.0844 10.8494Z"
                                              stroke="#868E96"
                                              strokeWidth="2.9602"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </div>
                                        <div className="dataWrap">
                                          <h2>
                                            Cabin or carry-on baggage
                                            information
                                          </h2>
                                          <p>
                                            1 cabin baggage that you can take
                                            for your whole trip.
                                          </p>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="btmFlightListWrapFixed">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="totalAmtWrap">
                  <h4>
                    Total Amount:
                    <span>
                      {" "}
                      {Currency} {" "} {Math.round(TotalPrice).toFixed(2)} {" "}
                    </span>
                    
                  </h4>
                  <div className="rightCtasWrap">
                    <button className="btn btnCancel">Cancel</button>
                    <button
                      className="btn"
                      onClick={() => saveFlightBookingDetails()}
                      disabled={!isValidated}
                    >
                      Procced To Book
                      <svg
                        width="6"
                        height="16"
                        viewBox="0 0 8 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.51172 1.89062L6.94029 11.3906L1.51172 20.8906"
                          stroke="white"
                          strokeWidth="1.80952"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default TwoWayFlights;
